import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import { CompInfoDependency } from '@wix/editor-elements-types';
import {
  ImpressDefinition,
  ImpressPropsCarmiData,
  ImpressPropsPlatformProps,
} from '../Impress.types';
import { props as viewerPropsMapper } from './Impress.mapper';

const viewerDeps = Object.keys(
  viewerPropsMapper.deps,
) as Array<CompInfoDependency>;

const props = withCompPreviewProps<
  ImpressPropsPlatformProps,
  ImpressDefinition,
  ImpressPropsCarmiData
>()(['isPlayingAllowed', ...viewerDeps], (deps, carmiData) => {
  const viewerProps = viewerPropsMapper.resolver(deps, carmiData);
  return {
    ...viewerProps,
    isPlayingAllowed: deps.isPlayingAllowed,
  };
});

export default createComponentPreviewMapperModel({
  props: props as any,
});
